

















import { Component, Vue } from "vue-property-decorator";
import { Button } from "vant";

@Component({
  name: 'FaceSuccess',
  components: {
    [Button.name]: Button
  }
})
export default class FaceSuccess extends Vue {
  // created() {
  //   const { tip } = this.$route.query;
  // }

  handleNext() {
    const { open_status, order_no, verify_action } = this.$route.query;
    const params = {
      open_status,
      order_no,
      open_type: 2,
      verify_action,
      is_verify: 2
    };
    (this as any).$apis
      .saveFaceInfo(params)
      .then(res => {
        
        this.$router.push({
          path: "/personal-info-supply",
          query: {
            open_status: open_status,
            open_type: "2" //常规开户
          }
        });
      })
      .catch(e => {
        
      });
  }
}
